import _EnvelopeIcon from "./EnvelopeIcon";
import _GithubIcon from "./GithubIcon";
import _LinkedinIcon from "./LinkedinIcon";
import _TwitterIcon from "./TwitterIcon";

export const EnvelopeIcon = _EnvelopeIcon
export const GithubIcon = _GithubIcon
export const LinkedinIcon = _LinkedinIcon
export const TwitterIcon = _TwitterIcon